module.exports = __webpack_public_path__ + "img/pr-2.db1d07eb.png";